import {
  Video,
  HandCoins,
  ClipboardList,
  HeartHandshake,
  HelpCircle,
} from "lucide-react";
import { useInView } from "@/hooks/useAnimations";

const services = [
  {
    icon: Video,
    title: "Online Pflegeberatung",
    desc: "Persönliche Beratung per Video-Call, bequem von zuhause — ohne Anfahrt und Wartezeiten.",
    color: "text-cyan-700",
    bg: "bg-cyan-50",
    borderColor: "border-cyan-100",
  },
  {
    icon: HandCoins,
    title: "Entlastungsbetrag (131€)",
    desc: "Erfahren Sie, wie Sie den monatlichen Entlastungsbetrag von 131€ sinnvoll nutzen können.",
    color: "text-green-600",
    bg: "bg-green-50",
    borderColor: "border-green-100",
  },
  {
    icon: ClipboardList,
    title: "Leistungen der Pflegekasse",
    desc: "Wir erklären Ihnen alle Leistungen, die Ihnen zustehen — verständlich und ohne Fachchinesisch.",
    color: "text-cyan-700",
    bg: "bg-cyan-50",
    borderColor: "border-cyan-100",
  },
  {
    icon: HeartHandshake,
    title: "Formulare & Bürokratie",
    desc: "Wir helfen bei Anträgen, Widersprüchen und dem gesamten Papierkram rund um die Pflege.",
    color: "text-green-600",
    bg: "bg-green-50",
    borderColor: "border-green-100",
  },
  {
    icon: HelpCircle,
    title: "Alltagsbegleitung",
    desc: "Beratung zu praktischen Hilfen im Alltag — damit Sie und Ihre Angehörigen entlastet werden.",
    color: "text-cyan-700",
    bg: "bg-cyan-50",
    borderColor: "border-cyan-100",
  },
];

export default function Services() {
  const [ref, isInView] = useInView();

  return (
    <section
      ref={ref}
      id="leistungen"
      data-testid="services-section"
      className="py-20 lg:py-28 bg-[#F8FAFC]"
      aria-label="Unsere Leistungen"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className={`text-center max-w-2xl mx-auto mb-14 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-sm font-semibold text-cyan-700 bg-cyan-50 px-4 py-1.5 rounded-full mb-4">
            Unsere Leistungen
          </span>
          <h2 className="font-['Manrope'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 mb-4">
            Wie wir Sie unterstützen
          </h2>
          <p className="text-base sm:text-lg text-slate-500 leading-relaxed">
            Von der laufenden Beratung bis zur Entlastung — wir begleiten Sie durch alle Fragen rund um die Pflege.
          </p>
        </div>

        {/* Service grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <div
              key={i}
              data-testid={`service-card-${i}`}
              className={`bg-white border ${s.borderColor} rounded-2xl p-7 hover:shadow-lg hover:-translate-y-1 transition-all duration-500 group ${i >= 3 ? 'lg:col-span-1 lg:last:col-start-2' : ''} ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: isInView ? `${i * 100}ms` : '0ms' }}
            >
              <div className={`h-12 w-12 ${s.bg} rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform`}>
                <s.icon className={`h-6 w-6 ${s.color}`} />
              </div>
              <h3 className="font-['Manrope'] text-xl font-semibold text-slate-800 mb-3">
                {s.title}
              </h3>
              <p className="text-base text-slate-500 leading-relaxed">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
